export let AppNotify = {};
import { Notification } from 'element-ui';
const defer = require('lodash/defer');

AppNotify.install = function (Vue, options) {
    Vue.prototype.$appNotify = {
        success: function (value) {
            if (typeof value === 'string') {
                value = [value];
            }

            if (!Array.isArray(value)) {
                console.error('Notify: Bad content');
                return false;
            }

            value.forEach(function (text) {
                if (typeof text !== 'string') {
                    console.error('Notify: Bad content');
                    return false;
                }

                defer(function() {
					Notification({
                        showClose: false,
						message: text,
                        customClass: 'add__notification'
					});
				});
            });

            return true;
        },
        error: function (value) {
            if (typeof value === 'string') {
                value = [value];
            } else if (typeof value === 'object') {
                let list = [];

                for (let key in value.errors) {
                    let message = value.errors[key][0];

                    if (typeof message === 'object') {
                        message = message[0];
                    }

                    list.push(value.errors[key][0]);
                }

                if (list.length <= 0 && value.message) {
                    list.push(value.message);
                }

                value = list;
            }

            value.forEach(function (text) {
                if (typeof text !== 'string') {
                    console.error('Notify: Bad content');
                    return false;
                }

                defer(function() {
                    Notification({
                        showClose: false,
                        message: text,
                        customClass: 'add__notification-error'
                    });
				});
            });

            return true;
        },
        warning: function (value) {
            if (typeof value === 'string') {
                value = [value];
            }

            if (!Array.isArray(value)) {
                console.error('Notify: Bad content');
                return false;
            }

            value.forEach(function (text) {
                if (typeof text !== 'string') {
                    console.error('Notify: Bad content');
                    return false;
                }

                defer(function() {
                    Notification({
                        showClose: false,
                        message: text,
                        customClass: 'add__notification-warning'
                    });
                });
            });

            return true;
        }
    }
};
